// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useInitiativeDataStore } from 'utilities/store';
import { useLabels, useContext, useFormat } from 'utilities/hooks';
import { useReportContent } from '../contentProviderHooks/';

// Components
import BaseCard from './_common/baseCard.js';

// Icons
import { FiShare2 } from 'react-icons/fi';

const SoMeSuggestion = ({ promptKey, forceOpen }) => {
    // ///////////////////
    // STORES
    // ///////////////////

    const { utilities } = useInitiativeDataStore();

    // ///////////////////
    // HOOKS
    // ///////////////////

    const { REPORT_ID } = useContext();
    const { label, getValueLabel } = useLabels();
    const { date } = useFormat();
    const { HiddenRender, getSanitizedHtml } = useReportContent();

    // ///////////////////
    // DATA
    // ///////////////////

    const initiative = utilities.initiative.get();
    const report = utilities.reports.get(REPORT_ID);

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            {HiddenRender}
            <BaseCard
                {...{
                    forceOpen,
                    title: label('AI_PromptTitle_SoMe_Suggestion'),
                    description: label('AI_PromptDescription_SoMe_Suggestion'),
                    relation: {
                        key: 'Initiative_Report__c',
                        id: REPORT_ID,
                        name: initiative?.Name,
                        type: `${getValueLabel(
                            'Initiative_Report__c.Report_Type__c',
                            report?.Report_Type__c
                        )} ${label('CardTypeReport')} (${date(
                            report?.Due_Date__c
                        )})`,
                    },
                    icon: FiShare2,
                    promptKey,
                    systemPrompts: [
                        'You are a social media expert.',
                        'You will help the user to create a post for social media. The post should be in the style of a social media post, not a formal report.',
                        'If the report content is not available or detailed enough, ask the user for more details.',
                        'End by outlining the funders, recipients and collaborators for easy tagging. Do not tag with "real" tags, as this could depend on platform - do @[funder] etc.',
                        'Add lots of emojis and hashtags.',
                        'Answer should be in unescaped html tags for immediate parsing. No wrapping <div>. Use <p> tags for spacing.',
                    ],
                    promptDataGetter: getSanitizedHtml,
                }}
            />
        </>
    );
};

SoMeSuggestion.propTypes = {
    promptKey: t.string.isRequired,
};

SoMeSuggestion.defaultProps = {
    promptKey: '',
};

export default SoMeSuggestion;
